module.exports = __webpack_public_path__ + "img/stock-m3.22e0bccc.png";